// mutations
const mutations = {
  showErrorMsg(state, error) {
    state.errorMsg = error.msg;
    state.errorAction = error.action ? error.action : '';

    // errorCode 統一處理
    if (error.errCode) {
      const tokenErrCodes = ['0001', '0002', '0003', '0004', '0006'];
      let tokenErr = tokenErrCodes.find((code) => {
        return code === error.errCode;
      });
      const denyErrCodes = ['0005', '0007'];
      let denyErr = denyErrCodes.find((code) => {
        return code === error.errCode;
      });
      if (tokenErr) {
        state.errorAction = 'main/redirectLogin';
      }
      if (denyErr) {
        state.errorAction = 'main/redirectWelcome';
      }
    }
  },
  clearErrorMsg(state) {
    state.errorMsg = '';
  },
  showSuccessMsg(state, success) {
    state.successMsg = success.msg;
    state.successAction = success.action ? success.action : '';
  },
  clearSuccessMsg(state) {
    state.successMsg = '';
  },
  mask(state, val) {
    state.mask = val;
    //測試用
    // setTimeout(() => (state.mask = false), 3000);
  },
  popup(state, val) {
    state.popup = val;
  },

  modifyLightApplyInfo(state, val) {
    state.lightApplyInfo = val;
  },
  clearLightApplyInfo(state) {
    state.lightApplyInfo = {
      name: '',
      phone: '',
      prayerList: [
        {
          lightType: [],
          name: '',
          sex: '',
          birthDate: '',
          birthHour: '',
          phone: '',
          address: '',
          givewayType: 0,
        },
      ],
      price: 0,
      paymentType: 0,
      payStatus: 0,
      fare: 0,
    };
  },
  modifyBanquetApplyInfo(state, val) {
    state.banquetApplyInfo = val;
  },
  clearBanquetApplyInfo(state) {
    state.banquetApplyInfo = {
      name: '',
      phone: '',
      calculateTypeOfMeat: 'desk',
      calculateTypeOfVegetable: 'desk',
      numberOfPeople: '',
      numberOfVegetarian: '',
    };
  },
  updateReferenceData(state, val) {
    state.referenceData = val;
  },
  updateOnlineStatusInfo(state, val) {
    state.onlineStatus = val;
  },
  updateOrderStatus(state, val) {
    state.orderStatus = val;
  },
  clearOrderStatus(state) {
    state.orderStatus = '';
  },
  updateBookingList(state, val) {
    state.bookingList = val;
  },
  clearBookingList(state) {
    state.bookingList = [];
  },
  updateBookingInfo(state, val) {
    state.bookingInfo = val;
  },
  clearBookingInfo(state) {
    state.bookingInfo = {};
  },
};

export default mutations;
